"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PartnersMessagesListCtl = /** @class */ (function (_super) {
    __extends(PartnersMessagesListCtl, _super);
    function PartnersMessagesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_message = UIUtils_1.UIUtils.IProp2Str(function (o) { o.message; });
        _this.dk_is_readed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_readed; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_readed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_readed; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersMessagesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PartnersMessagesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "Partner with id [" + id + "] not found !";
    };
    PartnersMessagesListCtl.prototype.LoadAllData = function (PartnerId, onDone) {
        var _this = this;
        webAApi_1.ListUsrPartnerMessageByPartnerIdGet.exec({ user_partner_id: PartnerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    message: resp.list[i].message,
                    is_readed: resp.list[i].is_readed,
                    date_readed: moment(resp.list[i].date_readed_uts_ms).utc(false),
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersMessagesListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListUsrPartnerMessageByPartnerIdAndDateRangeGet.exec({
            user_partner_id: data.usr_partner_id,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    message: resp.list[i].message,
                    is_readed: resp.list[i].is_readed,
                    date_readed: moment(resp.list[i].date_readed_uts_ms).utc(false),
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersMessagesListCtl.prototype.LoadUnreadedData = function (partnerId, onDone) {
        var _this = this;
        webAApi_1.ListPartnerMessagesUnreadByPartnerIdGet.exec({
            user_partner_id: partnerId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    message: resp.list[i].message,
                    is_readed: resp.list[i].is_readed,
                    date_readed: moment(resp.list[i].date_readed_uts_ms).utc(false),
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersMessagesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddUsrPartnerMessage.exec({
            usr_partner_id: data.usr_partner_id,
            title: data.title,
            message: data.message
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_readed: moment(resp.date_added_uts_ms).utc(false),
                is_readed: false,
                message: data.message,
                title: data.title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersMessagesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PartnersMessagesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteUsrPartnerMessage.exec({
                usr_partner_message_id: key,
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersMessagesListCtl.prototype.SetIsReaded = function (key, isReaded, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetUsrPartnerMessageIsReaded.exec({
                usr_partner_message_id: key,
                is_read: isReaded
            }, function (resp) {
                _tmp.is_readed = isReaded;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.date_readed = moment(resp.date_readed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersMessagesListCtl.prototype.DoSendBroadcastRawMsg = function (data, onDone) {
        var _this = this;
        webAApi_1.DoSendUsrPartnerBroadcastMessageRaw.exec({
            pprogram_id: data.pprogram_id,
            app_language_id: data.app_language_id,
            title: data.message_title,
            message: data.message_text
        }, function (resp) {
            if (onDone) {
                onDone(resp.sent_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PartnersMessagesListCtl;
}(BaseController_1.BaseController));
exports.PartnersMessagesListCtl = PartnersMessagesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersMessagesListCtl.ts
// module id = 997
// module chunks = 0